import { render, staticRenderFns } from "./InDmChatRow.vue?vue&type=template&id=af60947c&scoped=true"
import script from "./InDmChatRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./InDmChatRow.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InDmChatRow.vue?vue&type=style&index=0&id=af60947c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af60947c",
  null
  
)

export default component.exports